// @flow
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FormBoxTitle from "../../../../components/mui/app/formBoxTitle/formBoxTitle";
import PageContentWrapper from "../../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import QuickViewInfoWrap from "../../../../components/mui/app/quickViewInfoWrap/quickViewInfoWrap";
import SkeletonLoaderWrapper from "../../../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { API } from "../../../../helpers/constants";
import { handleAxiosErrors } from "../../../../helpers/errorHandling";
import useUserData from "../../../../hooks/user/useUserData";
import { ISSUES_FORM } from "../../locales/namespaces";
import {DataGridPremium} from "@mui/x-data-grid-premium";
import {muiGridLocales} from "../../../../helpers/mui/muiLocales";
import Typography from "@mui/material/Typography";
import TruncateDescription from "../../../../pages/dashboard/partials/truncateDescription";
import {numericFormatDigitDefaults} from "../../../../helpers/theme/defaultProps";


type Props = {};

const PoCustQuickView = (props: Props) => {
    const { Code, onClose } = props
    const { t } = useTranslation(ISSUES_FORM)
    const { token,thousandSeparator,decimalSeparator,language } = useUserData()
    const [po, setPo] = useState([])

    useEffect(() => {
        if (Code) {
            axios({
                method: 'post',
                url: API + '/en/custom/customer/purchase/workOrder/quickview',
                data:{
                    Code:Code
                },
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
            }).then(res => {
                setPo(res.data.data)
                console.log('data',res.data.data)
            }).catch(error => {
                enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                    variant: 'error',
                    autoHideDuration: 3000,
                })
            })
        }
    }, [Code, t,])

    const totalChargeCost = React.useMemo(() => {
        return (po || []).reduce((sum, row) => {
            return sum + (Number(row.ChargeCost) || 0);
        }, 0);
    }, [po]);

    const totalRow = useMemo(() => ({
        Code: t("Total"),
        Description: "",
        CustName: "",
        Address: "",
        ChargeCost: totalChargeCost,
    }), [totalChargeCost, t]);

    const columns = useMemo(() => [
        {
            field: 'Code',
            headerName: t('Code'),
            description: t('Code'),
            minWidth: 100,
            flex: 1,
            renderCell: (params) => {
                const isTotal = params.value === t("Total");
                return (
                    <Typography fontWeight={isTotal ? 700 : 400}>
                        {params.value}
                    </Typography>
                );
            }
        },
        {
            field: 'Description',
            headerName: t('Description'),
            description: t('Description'),
            minWidth: 200,
            flex: 1,
            renderCell: (params) => {
                return <TruncateDescription value={params.value}/>
            },
        },
        {
            field: 'CustName',
            headerName: t('Customer'),
            description: t('Customer'),
            minWidth: 250,
            flex: 1,
            renderCell: (params) => {
                return <TruncateDescription value={params.value}/>
            },
        },
        {
            field: 'Site',
            headerName: t('Site'),
            description: t('Site'),
            minWidth: 250,
            flex: 1,
            renderCell: (params) => {
                return <TruncateDescription value={params.value}/>
            },
        },
        {
            field: 'ChargeCost',
            headerName: t('Charge'),
            description: t('Charge'),
            minWidth: 100,
            type: 'number',
            flex: 1,
            valueGetter: (value, row, column, apiRef) => value ? Number(value) : 0,
            renderCell: (params) => {
                const isTotal = params.row.Code === t("Total");

                return (
                    <NumericFormat
                        {...numericFormatDigitDefaults}
                        thousandSeparator={thousandSeparator}
                        decimalSeparator={decimalSeparator}
                        displayType="text"
                        value={params.value}
                        style={{ fontWeight: isTotal ? 700 : 400 }}
                    />
                );
            }

        }

    ], [t])

    return (
        <SkeletonLoaderWrapper loading={!Boolean(po)}>
            <Box
                sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}
            >
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: "wrap-reverse",
                    gap: 0.2,
                    pt:2,
                    pr:2
                }}>
                    <IconButton
                        onClick={onClose}
                        color={'error'}
                        size={'small'}
                        sx={{ marginLeft: 'auto' }}
                    >
                        <ClearIcon/>
                    </IconButton>
                </Box>
                <PageContentWrapper>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <FormBoxTitle
                                    title={t('Γενικά στοιχεία P.O Πελάτη')}
                                />
                            </Grid>
                            <Grid size={{ xs: 12}}>
                                <Box sx={{width:'93%',ml:2}}>
                                    <DataGridPremium
                                        rows={po}
                                        columns={columns}
                                        getRowId={(row)=>row.Code}
                                        pinnedRows={{
                                            bottom: [totalRow],
                                        }}

                                        hideFooterPagination
                                        hideFooterSelectedRowCount
                                        initialState={{
                                            density: 'compact'
                                        }}
                                        slots={{
                                            //pagination: CustomPagination,
                                        }}
                                        slotProps={{
                                            toolbar: {
                                                t: t,
                                            }
                                        }}
                                        disableSelectionOnClick
                                        localeText={muiGridLocales(language)}
                                    />
                                </Box>


                            </Grid>
                        </Grid>
                    </Box>
                </PageContentWrapper>
            </Box>
        </SkeletonLoaderWrapper>
    );
};

export default PoCustQuickView